module.exports = __webpack_public_path__ + "static/media/bg_login_b-1.1580d0a2.jpg";